module.exports = __webpack_public_path__ + "assets/img/haveObtained_Exchange.b75004b2.png";